import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnClose = (legalEntityId: number) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return () => {
    navigate(
      navigation.settings.legalEntitiesId.employeeGroups.fullPath({
        id: legalEntityId,
      })
    )
  }
}
